import { createContext, useContext } from 'react';
import classnames from 'classnames';

import style from './app-brand.less';
import { Logos } from './logo/assets';

import type React from 'react';
import './concepts/shipstation-concept-layer-default.less';

/**
 * The name of our application.
 */
export const ShipStation = 'ShipStation';

export const Themes = {
  Default: 'default-theme' as const,
};

export type BrandDetails = {
  AppHeaderLogoSrc: string;
  SetupPageLogoSrc: string;
  theme: string;
};

const BrandContext = createContext<BrandDetails>({} as BrandDetails);

/**
 * Returns various re-/brand specific values
 */
export const useAppBrandContext = (): BrandDetails => useContext(BrandContext);

const defaultBrandDetails: BrandDetails = {
  AppHeaderLogoSrc: Logos.AppHeaderLogo,
  SetupPageLogoSrc: Logos.SetupPageLogo,
  theme: Themes.Default,
};

/**
 * Context Provider that controls branding and theming for the app.
 */
export const AppBrandContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <BrandContext.Provider value={defaultBrandDetails}>
      <div className={classnames(style['app-brand'], defaultBrandDetails.theme)}>{children}</div>
    </BrandContext.Provider>
  );
};
